import { cn } from 'src/lib/utils';
import { portalDs } from './portal-ds-classes';

interface PortalDsAnswerBarProps {
  label: string;
  percent: number;
  count: number;
  leading?: boolean;
  className?: string;
}

export function PortalDsAnswerBar({
  label,
  percent,
  count,
  leading = false,
  className,
}: PortalDsAnswerBarProps) {
  const clamped = Math.max(0, Math.min(100, percent));
  return (
    <div className={cn(portalDs.answerBar, className)}>
      <div className={portalDs.answerBarRow}>
        <span
          className={cn(
            portalDs.answerBarLabel,
            leading && portalDs.answerBarLabelLeading
          )}
        >
          {label}
        </span>
        <span className={portalDs.answerBarFigures}>
          {clamped.toFixed(1)}
          % · n=
          {count}
        </span>
      </div>
      <div className={portalDs.answerBarTrack}>
        <div
          className={leading ? portalDs.answerBarFillLeading : portalDs.answerBarFill}
          style={{ width: `${clamped}%` }}
        />
      </div>
    </div>
  );
}
